import 'css-chunksrc/client/scenes/optimizedGantt/header/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_dx36o_1",
  "input": "_input_dx36o_7",
  "toggleArrow": "_toggleArrow_dx36o_23",
  "selectedDataTypes": "_selectedDataTypes_dx36o_31",
  "placeholder": "_placeholder_dx36o_40",
  "list": "_list_dx36o_45",
  "item": "_item_dx36o_57",
  "typeName": "_typeName_dx36o_70",
  "opened": "_opened_dx36o_77"
};